var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class AjaxLoaderRequest {
    constructor(apiUrl, isMobileShop) {
        this.apiUrl = apiUrl;
        this.isMobileShop = isMobileShop;
    }
    requestFor(savKeyToLoad_1, content_1) {
        return __awaiter(this, arguments, void 0, function* (savKeyToLoad, content, itemOrigin = null, detailsCanBeHidden = false, displayedInCategoryNavKey = '', showHeader = true) {
            const url = this.getAjaxUrl(savKeyToLoad, content, itemOrigin, detailsCanBeHidden, displayedInCategoryNavKey, showHeader);
            const controller = new AbortController();
            const timeout = 30000;
            const timeoutId = setTimeout(() => controller.abort(), timeout);
            try {
                const response = yield fetch(url, { method: 'GET' });
                clearTimeout(timeoutId);
                if (!response.ok || response.status === 204) {
                    return '';
                }
                return yield response.text();
            }
            catch (_error) {
                return '';
            }
        });
    }
    getAjaxUrl(savKey, content, itemOrigin, detailsCanBeHidden, displayedInCategoryNavKey, showHeader) {
        const params = new URLSearchParams({
            viewMode: 'ajax',
            maxNumberOfAlternativeArticles: '3',
            isMobileShop: String(this.isMobileShop),
            content,
            detailsCanBeHidden: String(detailsCanBeHidden),
            showHeader: String(showHeader),
        });
        if (itemOrigin) {
            params.append('itemorigin', itemOrigin);
        }
        if (displayedInCategoryNavKey) {
            params.append('displayedInCategoryNavKey', displayedInCategoryNavKey);
        }
        return `${this.apiUrl}articles/${savKey}?${params.toString()}`;
    }
}
